/* ==== chrome.js ==== */
/* Le Petit Spa Charlotte -- page chrome.
   Plain ES5, no dependencies of any kind. Owns exactly two things: the
   header's scrolled state, and the mobile menu (open/close, focus trap,
   Escape, body scroll lock). Nothing else lives here. */
(function () {
  "use strict";

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------------------------------------------------------------- header */
  var hdr = document.querySelector("[data-hdr]");
  if (hdr) {
    var ticking = false;
    var onScroll = function () {
      hdr.classList.toggle("is-scrolled", window.scrollY > 40);
      ticking = false;
    };
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
    }, { passive: true });
    onScroll();
  }

  /* ---------------------------------------------------------------- mobile menu */
  var menu = document.querySelector("[data-menu]");
  var openBtn = document.querySelector("[data-menu-open]");
  var closeBtn = document.querySelector("[data-menu-close]");

  if (menu && openBtn) {
    var lastFocus = null;
    var hideTimer = null;

    var focusables = function () {
      return Array.prototype.filter.call(
        menu.querySelectorAll("a[href], button:not([disabled])"),
        function (el) { return el.offsetParent !== null; }
      );
    };

    var openMenu = function () {
      window.clearTimeout(hideTimer);
      lastFocus = document.activeElement;
      menu.hidden = false;
      requestAnimationFrame(function () { menu.classList.add("is-open"); });
      /* both classes land on <body>: is-locked stops background scroll,
         menu-open is the hook motion.js and chrome.css watch to hide the
         mobile bookbar while the menu is up. */
      document.body.classList.add("is-locked");
      document.body.classList.add("menu-open");
      openBtn.setAttribute("aria-expanded", "true");
      var f = focusables();
      if (f.length) f[0].focus();
    };

    var closeMenu = function () {
      menu.classList.remove("is-open");
      document.body.classList.remove("is-locked");
      document.body.classList.remove("menu-open");
      openBtn.setAttribute("aria-expanded", "false");
      var done = function () { menu.hidden = true; };
      window.clearTimeout(hideTimer);
      if (reduced) { done(); } else { hideTimer = window.setTimeout(done, 320); }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };

    openBtn.addEventListener("click", openMenu);
    if (closeBtn) closeBtn.addEventListener("click", closeMenu);

    menu.addEventListener("click", function (e) {
      if (e.target === menu) closeMenu();
      if (e.target.closest && e.target.closest(".mmenu__nav a")) closeMenu();
    });

    document.addEventListener("keydown", function (e) {
      if (menu.hidden) return;
      if (e.key === "Escape") { closeMenu(); return; }
      if (e.key !== "Tab") return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* a resize past the mobile breakpoint must not strand a locked body */
    window.addEventListener("resize", function () {
      if (!menu.hidden && window.innerWidth > 860) closeMenu();
    });
  }
  /* ------------------------------------------------ real header height
     --header-h is a hardcoded guess (88px desktop, 64px mobile) and the mobile
     value is simply wrong: below 860px the wordmark lockup wraps and the header
     actually renders about 93px. Everything offsetting against the token
     inherits the error. The worst case was the sticky treatment nav on
     /services, which stuck at top:64px and sat 29px UNDER the header (the
     header wins, z-index 90 against 40), clipping the category pills.

     IT MUST NOT WRITE BACK TO --header-h. chrome.css gives .hdr__in
     "min-height: var(--header-h)", so measuring the header and assigning the
     result to --header-h is a feedback loop: the header grows to the measured
     height, which is then measured again. It ran to 1275px on a 390px phone
     before this was caught. So the measurement is published as a SEPARATE
     property, --header-real, and every consumer reads
     var(--header-real, var(--header-h)) with the static token as the fallback
     for no-JS. --header-h keeps driving min-height and never changes. */
  /* Named headerBar, NOT hdr. The scroll-shadow feature at the top of this file
     already has a `var hdr`, and `var` is function-scoped, so a second `var hdr`
     here silently rebinds the SAME variable. It happens to be harmless today only
     because [data-hdr] and .hdr are the same element; the moment the markup put
     them on different nodes, onScroll would start watching the wrong one with no
     error anywhere. */
  var headerBar = document.querySelector(".hdr");
  if (headerBar) {
    var applyHeaderHeight = function () {
      var h = Math.round(headerBar.getBoundingClientRect().height);
      if (h > 0) document.documentElement.style.setProperty("--header-real", h + "px");
    };
    applyHeaderHeight();
    if (window.ResizeObserver) new ResizeObserver(applyHeaderHeight).observe(headerBar);
    else window.addEventListener("resize", applyHeaderHeight);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(applyHeaderHeight);
  }
})();

/* VIP waitlist confirmation. Shopify's customer form redirects back with
   ?customer_posted=true#vip-waitlist, so that param swaps the form for the
   thank-you note. Off Shopify (localhost, the review artifact) there is no
   /contact endpoint, so the submit is stopped and the note shown instead. */
(function () {
  var form = document.querySelector("[data-waitlist], #vip-waitlist-form");
  var done = document.querySelector("[data-waitlist-done]");
  /* Shopify sends the visitor back to the referring path, which can drop the
     page (a ?view= preview lands on the home page). Wherever they land, take
     them to the membership thank-you so the sign-up is always acknowledged. */
  if (!form && /[?&]customer_posted=true/.test(location.search) && /vip-waitlist/.test(location.hash)) {
    location.replace("/pages/membership?customer_posted=true#vip-waitlist");
    return;
  }
  if (!form || !done) return;
  var show = function () {
    form.hidden = true;
    done.hidden = false;
  };
  if (/[?&]customer_posted=true/.test(location.search)) show();
  var onShopify = !!(window.Shopify && window.Shopify.shop);
  if (!onShopify) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      show();
      done.scrollIntoView({ block: "center" });
    });
    return;
  }
  /* On Shopify the form is rendered by {% form 'customer' %}, and Shopify's
     invisible CAPTCHA hooks the browser's own submit. So this handler never
     cancels or replays the submit: it only tidies values and adds the answer
     tags (filterable under Customers) before the native submit carries on. */
  form.addEventListener("submit", function (e) {
    var trap = form.querySelector('[name="wl_website"]');
    if (trap && trap.value) { e.preventDefault(); show(); return; }
    form.querySelectorAll("input:not([type=hidden]), textarea").forEach(function (el) {
      if (el !== trap) el.value = el.value.trim();
    });
    var pick = function (n) {
      var el = form.querySelector('[name="contact[note][' + n + ']"]');
      return el ? el.value.replace(/,/g, " ").trim() : "";
    };
    var tags = form.querySelector('[name="contact[tags]"]');
    if (tags) tags.value = ["vip-waitlist",
      "VIP Location: " + pick("Preferred Location"),
      "VIP Visited: " + pick("Current Guest"),
      "VIP Heard: " + pick("Heard Via")].join(", ");
    if (trap) trap.disabled = true;
  });
})();

/* Treatment guides: every category open on tablet and desktop, collapsed on phones
   so 79 links do not become a 4,000px wall. Without JS they stay collapsed but the
   links are still in the HTML for crawlers. */
(function () {
  var cols = document.querySelectorAll("[data-guides]");
  if (!cols.length) return;
  var mq = window.matchMedia("(min-width: 601px)");
  var sync = function () { cols.forEach(function (d) { d.open = mq.matches; }); };
  sync();
  if (mq.addEventListener) mq.addEventListener("change", sync);
  cols.forEach(function (d) {
    d.querySelector("summary").addEventListener("click", function (e) { if (mq.matches) e.preventDefault(); });
  });
})();

/* ==== motion.js ==== */
/* Le Petit Spa Charlotte -- motion. Dependency-free ES5 IIFE: no gsap, no
   Lenis, no ScrollTrigger, no scroll-jacking/pinning/parallax, no canvas or
   WebGL, no count-up numbers. Each function below is one feature, is a
   silent no-op if its markup is absent, and respects prefers-reduced-motion
   on its own. Passive listeners only; layout is read via IntersectionObserver
   or rAF-throttled pointer events, never on a raw scroll frame. */
(function () {
  "use strict";

  var noop = function () {};
  var reduced = false;
  try { reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) {}
  var hasIO = "IntersectionObserver" in window;
  var hasHover = true;
  try { hasHover = window.matchMedia("(hover: hover)").matches; } catch (e2) {}
  var toArray = function (list) { return Array.prototype.slice.call(list || []); };

  /* Adds `is-in` to each el on viewport entry, then unobserves; with no IO,
     adds it immediately. Shared by reveal(), splitLines(), wordRise(). */
  var revealOnEnter = function (els) {
    if (!hasIO) { toArray(els).forEach(function (el) { el.classList.add("is-in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        /* A ratio alone never fires on a block taller than about eight
           viewports: the waxing menu is 5243px on a 375px phone, so it could
           never be 12% visible and stayed invisible. Also accept "fills 30%
           of the viewport", which any tall block reaches. */
        var root = entry.rootBounds;
        var fills = root && entry.intersectionRect.height >= root.height * 0.3;
        if (entry.intersectionRatio < 0.12 && !fills) return;
        entry.target.classList.add("is-in");
        io.unobserve(entry.target);
      });
    }, { threshold: [0, 0.02, 0.05, 0.08, 0.12], rootMargin: "0px 0px -8% 0px" });
    toArray(els).forEach(function (el) { io.observe(el); });
  };

  /* Toggles a class on hover (pointerenter/leave) and focus (focusin/out) --
     shared by brandLoop(), flowingMenu(), cardSwap(). */
  var bindHoverFocus = function (el, cls) {
    var set = function (v) { el.classList.toggle(cls, v); };
    el.addEventListener("pointerenter", function () { set(true); }, { passive: true });
    el.addEventListener("pointerleave", function () { set(false); }, { passive: true });
    el.addEventListener("focusin", function () { set(true); });
    el.addEventListener("focusout", function () { set(false); });
  };

  /* ================================================================ reveal
     Markup owns `.rv`; base.css owns the transition, we only toggle `is-in`. */
  (function reveal() {
    var els = document.querySelectorAll(".rv");
    if (!els.length) return;
    if (reduced) { toArray(els).forEach(function (el) { el.classList.add("is-in"); }); return; }
    revealOnEnter(els);
  })();

  /* ------------------------------------------------------------- word split
     Shared by splitLines()/wordRise(): flattens text into word tokens
     (remembering which sat inside <em>/<i>), then rebuilds one top-level
     node per word -- a bare <span class="w-tmp"> or an <em> wrapping one --
     so each unit's own rect can be measured without a word spanning lines. */
  var tokenize = function (node, emDepth) {
    var tokens = [];
    toArray(node.childNodes).forEach(function (child) {
      if (child.nodeType === 3) {
        (child.nodeValue || "").split(/\s+/).forEach(function (w) { if (w) tokens.push({ text: w, em: emDepth > 0 }); });
      } else if (child.nodeType === 1) {
        tokens = tokens.concat(tokenize(child, emDepth + (/^(EM|I)$/.test(child.tagName) ? 1 : 0)));
      }
    });
    return tokens;
  };
  var rebuildWords = function (el, tokens) {
    el.innerHTML = "";
    tokens.forEach(function (tok, i) {
      var w = document.createElement("span");
      w.className = "w-tmp";
      w.textContent = tok.text;
      var unit = w;
      if (tok.em) { unit = document.createElement("em"); unit.appendChild(w); }
      el.appendChild(unit);
      if (i < tokens.length - 1) el.appendChild(document.createTextNode(" "));
    });
  };

  /* ===================================================== line-wipe headline
     [data-split]: split into LINES, never characters. Re-splits on resize
     (line breaks change), debounced 150ms. Reduced motion: leave text as-is. */
  (function splitLines() {
    var els = document.querySelectorAll("[data-split]");
    if (!els.length || reduced) return;

    var build = function (el) {
      if (el.__origHTML === undefined) el.__origHTML = el.innerHTML;
      el.innerHTML = el.__origHTML;
      var tokens = tokenize(el, 0);
      if (!tokens.length) return;
      rebuildWords(el, tokens);

      /* Group words into lines by vertical position. A 2px tolerance USED to be
         used here and it tore headlines apart: a word inside <em> renders in the
         editorial face (Bodoni Moda), whose ascent is taller than the display
         face, so its own border box sits well above its line-mates and it got
         pushed onto a line of its own along with any adjacent punctuation.
         Compare against the MIDPOINT of each word and allow half a line-height,
         which is stable across mixed fonts on one line. */
      var lineH = parseFloat(getComputedStyle(el).lineHeight);
      if (!lineH || isNaN(lineH)) lineH = parseFloat(getComputedStyle(el).fontSize) * 1.2;
      var tol = Math.max(4, lineH * 0.5);

      var lines = [], lastMid = null;
      toArray(el.querySelectorAll(".w-tmp")).forEach(function (leaf) {
        var r = leaf.getBoundingClientRect();
        var mid = r.top + r.height / 2;
        if (lastMid === null || Math.abs(mid - lastMid) > tol) { lines.push([]); lastMid = mid; }
        lines[lines.length - 1].push(leaf.parentNode.tagName === "EM" ? leaf.parentNode : leaf);
      });

      el.innerHTML = "";
      lines.forEach(function (units, i) {
        var inner = document.createElement("span");
        units.forEach(function (u, j) {
          inner.appendChild(u);
          if (j < units.length - 1) inner.appendChild(document.createTextNode(" "));
        });
        inner.style.transitionDelay = (i * 70) + "ms";
        var outer = document.createElement("span");
        outer.className = "ln";
        outer.appendChild(inner);
        el.appendChild(outer);
      });
    };

    toArray(els).forEach(function (el) { build(el); el.classList.add("is-split"); });
    revealOnEnter(els);

    var resizeTimer = null;
    window.addEventListener("resize", function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        toArray(els).forEach(function (el) {
          var wasIn = el.classList.contains("is-in");
          build(el);
          if (wasIn) el.classList.add("is-in");
        });
      }, 150);
    }, { passive: true });
  })();

  /* ============================================================ word rise
     [data-words]: wrap each word, stagger transition-delay 35ms, enter same
     as reveal(). Reduced motion: leave text as-is. */
  (function wordRise() {
    var els = document.querySelectorAll("[data-words]");
    if (!els.length || reduced) return;
    toArray(els).forEach(function (el) {
      var tokens = tokenize(el, 0);
      if (!tokens.length) return;
      rebuildWords(el, tokens);
      toArray(el.querySelectorAll(".w-tmp")).forEach(function (w, i) {
        (w.parentNode.tagName === "EM" ? w.parentNode : w).style.transitionDelay = (i * 35) + "ms";
      });
    });
    revealOnEnter(els);
  })();

  /* ============================================================= brand loop
     [data-loop] is the moving track itself; duplicate its own children once
     so a CSS translate(-50%) marquee is seamless. Pause on hover/focus via
     is-paused. Reduced motion: no duplication, animation removed entirely. */
  (function brandLoop() {
    toArray(document.querySelectorAll("[data-loop]")).forEach(function (track) {
      if (reduced) { track.style.animation = "none"; return; }
      var original = toArray(track.children);
      if (!original.length) return;
      original.forEach(function (node) { track.appendChild(node.cloneNode(true)); });
      bindHoverFocus(track, "is-paused");
    });
  })();

  /* =========================================================== flowing menu
     [data-flow-row]: CSS drives the sage fill + image strip on :hover; this
     adds keyboard-focus parity and touch pointer support (is-active), and
     only runs the row's .flow__strip marquee while active (is-playing) so
     idle rows aren't animating off screen and burning frames. */
  (function flowingMenu() {
    toArray(document.querySelectorAll("[data-flow-row]")).forEach(function (row) {
      var strip = row.querySelector(".flow__strip");
      var set = function (v) {
        row.classList.toggle("is-active", v);
        if (strip) strip.classList.toggle("is-playing", v && !reduced);
      };
      row.addEventListener("pointerenter", function () { set(true); }, { passive: true });
      row.addEventListener("pointerleave", function () { set(false); }, { passive: true });
      row.addEventListener("focusin", function () { set(true); });
      row.addEventListener("focusout", function () { set(false); });
    });
  })();

  /* ======================================================== accordion gallery
     [data-acc] panels: CSS handles hover; this adds click/tap + keyboard,
     toggling is-open on the target and removing it from siblings. Below
     900px the CSS stacks the panels, so this does nothing. */
  (function accordionGallery() {
    var panels = document.querySelectorAll("[data-acc]");
    if (!panels.length) return;
    var open = function (panel) {
      if (window.innerWidth < 900) return;
      toArray(panel.parentNode ? panel.parentNode.children : []).forEach(function (sib) {
        if (sib.hasAttribute && sib.hasAttribute("data-acc")) sib.classList.remove("is-open");
      });
      panel.classList.add("is-open");
    };
    toArray(panels).forEach(function (panel) {
      if (!panel.hasAttribute("tabindex")) panel.setAttribute("tabindex", "0");
      panel.addEventListener("click", function () { open(panel); });
      panel.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") { e.preventDefault(); open(panel); }
      });
    });
  })();

  /* cardSwap() was deleted here. It bound a hover cross-fade to [data-swap]
     cards, and no page has ever carried that attribute: no [data-swap] in any
     src/*.html, and no .swap__a / .swap__b / .is-swapped rule in any css file.
     It ran a querySelectorAll on every page load to find nothing. */

  /* ============================================================= subtle tilt
     [data-tilt]: pointer-tracked rotateX/rotateY capped at 3deg, rAF-
     throttled. Off entirely on touch and under reduced motion. */
  (function tilt() {
    var els = document.querySelectorAll("[data-tilt]");
    if (!els.length || reduced || !hasHover) return;
    var CAP = 3;
    toArray(els).forEach(function (el) {
      var raf = null, pending = null;
      var apply = function () {
        raf = null;
        if (!pending) return;
        var rect = el.getBoundingClientRect();
        var px = (pending.x - rect.left) / rect.width, py = (pending.y - rect.top) / rect.height;
        var rx = Math.max(-CAP, Math.min(CAP, (0.5 - py) * (CAP * 2)));
        var ry = Math.max(-CAP, Math.min(CAP, (px - 0.5) * (CAP * 2)));
        el.style.transform = "perspective(900px) rotateX(" + rx.toFixed(2) + "deg) rotateY(" + ry.toFixed(2) + "deg)";
      };
      el.addEventListener("pointermove", function (e) {
        if (e.pointerType === "touch") return;
        pending = { x: e.clientX, y: e.clientY };
        if (!raf) raf = requestAnimationFrame(apply);
      }, { passive: true });
      el.addEventListener("pointerleave", function () {
        pending = null;
        if (raf) { cancelAnimationFrame(raf); raf = null; }
        el.style.transform = "";
      }, { passive: true });
    });
  })();

  /* ================================================================= reels
     figure.reel > video.reel__video[data-src], img.reel__fallback (shown by
     CSS until figure gets .has-video), button.reel__unmute. */
  (function reels() {
    var figures = document.querySelectorAll("figure.reel");
    if (!figures.length) return;
    var videos = [];

    toArray(figures).forEach(function (fig) {
      var video = fig.querySelector(".reel__video");
      var btn = fig.querySelector(".reel__unmute");
      if (!video) return;
      var src = video.getAttribute("data-src");
      var loaded = false;

      if (src) {
        videos.push(video);
        var startLoad = function () {
          if (loaded) return;
          loaded = true;
          video.src = src;
          video.load();
          video.addEventListener("canplay", function () {
            fig.classList.add("has-video");
            video.play().catch(noop);
          });
        };
        if (hasIO) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) { startLoad(); if (!document.hidden) video.play().catch(noop); }
              else if (loaded) { video.pause(); }
            });
          }, { rootMargin: "200px" }).observe(fig);
        } else {
          startLoad();
        }
      }

      if (btn) {
        btn.addEventListener("click", function () {
          video.muted = !video.muted;
          if (!video.muted) {
            /* only one reel plays with sound at a time */
            videos.forEach(function (v) { if (v !== video) v.muted = true; });
            toArray(figures).forEach(function (other) {
              if (other === fig) return;
              var otherBtn = other.querySelector(".reel__unmute");
              if (otherBtn) { otherBtn.setAttribute("aria-pressed", "false"); otherBtn.textContent = "Unmute"; }
            });
          }
          btn.setAttribute("aria-pressed", String(!video.muted));
          btn.textContent = video.muted ? "Unmute" : "Mute";
        });
      }
    });

    if (videos.length) {
      document.addEventListener("visibilitychange", function () {
        if (document.hidden) { videos.forEach(function (v) { v.pause(); }); return; }
        toArray(figures).forEach(function (fig) {
          if (!fig.classList.contains("has-video")) return;
          var r = fig.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) {
            var v = fig.querySelector(".reel__video");
            if (v) v.play().catch(noop);
          }
        });
      });
    }
  })();

  /* ============================================ pinned reel rail (phones)
     Home .reels only. On a phone the three reels overflow sideways and were easy
     to scroll straight past. When the rail overflows, it is wrapped in a tall
     .reels-pin whose inner block is sticky; vertical scroll progress through the
     pin maps to translateX on the rail, so every reel crosses the screen before
     the page continues. Rebuilt on resize; undone above 640px and for reduced
     motion, where the plain swipeable rail is left alone. */
  (function pinnedReels() {
    var rail = document.querySelector(".founder .reels, .reels");
    if (!rail || reduced || !window.matchMedia) return;
    var mq = window.matchMedia("(max-width: 640px)");
    var pin = null, sticky = null, dist = 0, ticking = false;
    var SLOW = 1.35; /* vertical px of scroll per horizontal px of travel */

    function update() {
      ticking = false;
      if (!pin) return;
      /* How far the sticky block has travelled down its pin is the exact scroll
         progress, whatever the header or the iOS toolbar did to its top. */
      var off = sticky.getBoundingClientRect().top - pin.getBoundingClientRect().top;
      var span = pin.offsetHeight - sticky.offsetHeight;
      var p = span > 0 ? Math.min(1, Math.max(0, off / span)) : 0;
      rail.style.transform = "translate3d(" + (-p * dist).toFixed(1) + "px,0,0)";
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    function measure() {
      if (!pin) return;
      rail.style.transform = "";
      dist = Math.max(0, rail.scrollWidth - sticky.clientWidth);
      var h = rail.offsetHeight;
      var bar = document.querySelector(".bookbar");
      /* The sticky top itself is CSS (dvh based), so it tracks iOS Safari's
         collapsing toolbar live; JS only supplies the two heights it needs. */
      sticky.style.setProperty("--rail-h", h + "px");
      sticky.style.setProperty("--bar-h", (bar ? bar.offsetHeight : 0) + "px");
      pin.style.height = (h + dist * SLOW) + "px";
      update();
    }
    function build() {
      if (pin || !mq.matches) return;
      if (rail.scrollWidth <= rail.clientWidth + 4) return;
      pin = document.createElement("div"); pin.className = "reels-pin";
      sticky = document.createElement("div"); sticky.className = "reels-pin__sticky";
      rail.parentNode.insertBefore(pin, rail);
      sticky.appendChild(rail); pin.appendChild(sticky);
      rail.classList.add("is-pinned");
      rail.scrollLeft = 0;
      measure();
      window.addEventListener("scroll", onScroll, { passive: true });
    }
    function teardown() {
      if (!pin) return;
      window.removeEventListener("scroll", onScroll);
      rail.classList.remove("is-pinned");
      rail.style.transform = "";
      pin.parentNode.insertBefore(rail, pin);
      pin.parentNode.removeChild(pin);
      pin = sticky = null;
    }
    function sync() { if (mq.matches) { if (pin) measure(); else build(); } else teardown(); }
    var rt;
    window.addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(sync, 150); });
    if (document.readyState === "complete") sync(); else window.addEventListener("load", sync);
  })();

  /* ============================================ founder Read More (phones)
     Toggles the rest of Priti's story. On collapse, if the button has scrolled
     above the screen, bring the section's start back into view so the reader
     is not left staring at the next section. */
  (function founderMore() {
    var btn = document.querySelector("[data-founder-more]");
    var rest = document.getElementById("founder-rest");
    if (!btn || !rest) return;
    btn.addEventListener("click", function () {
      var open = !rest.classList.contains("is-open");
      rest.classList.toggle("is-open", open);
      btn.setAttribute("aria-expanded", String(open));
      btn.textContent = open ? "Show Less" : "Read More";
      if (!open) {
        /* after collapsing, make sure the start of the story is on screen, just
           under the sticky header, rather than somewhere above it */
        var copy = btn.closest(".founder__copy") || btn;
        var hdr = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--header-real")) || 72;
        var top = copy.getBoundingClientRect().top;
        if (top < hdr) window.scrollBy({ top: top - hdr - 12, behavior: reduced ? "auto" : "smooth" });
      }
    });
  })();

  /* ================================================== sticky group nav
     services.html: [data-menu-nav] links pair to [data-menu-group] sections
     by hash. Highlight class "is-active"; click smooth-scrolls. The pages
     agent owns `scroll-margin-top` on [data-menu-group] sections (header +
     jump-bar height) so scrollIntoView lands below the fixed chrome. */
  (function groupNav() {
    var nav = document.querySelector("[data-menu-nav]");
    if (!nav) return;
    var links = nav.querySelectorAll("a[href^='#']");
    if (!links.length) return;

    var pairs = [];
    toArray(links).forEach(function (a) {
      var id = a.getAttribute("href").slice(1);
      var sec = id && document.querySelector("[data-menu-group='" + id + "']");
      if (sec) pairs.push({ link: a, sec: sec });
    });
    if (!pairs.length) return;

    var setActive = function (id) {
      pairs.forEach(function (p) { p.link.classList.toggle("is-active", p.sec.getAttribute("data-menu-group") === id); });
    };
    /* Which category is being read: the section that crosses a line just below the
       sticky nav. Not intersectionRatio: a very tall section (Waxing, ~3000px) can
       never show more than a third of itself, so a short neighbour that is fully on
       screen used to win the highlight even while the reader was in Waxing. */
    var lockUntil = 0;
    var pick = function () {
      if (Date.now() < lockUntil) return;
      var line = nav.getBoundingClientRect().bottom + 24;
      var id = null;
      pairs.forEach(function (p) {
        if (p.sec.getBoundingClientRect().top <= line) id = p.sec.getAttribute("data-menu-group");
      });
      setActive(id || pairs[0].sec.getAttribute("data-menu-group"));
    };

    toArray(links).forEach(function (a) {
      a.addEventListener("click", function (e) {
        var id = a.getAttribute("href").slice(1);
        var sec = document.querySelector("[data-menu-group='" + id + "']");
        if (!sec) return;
        e.preventDefault();
        setActive(id);
        lockUntil = Date.now() + (reduced ? 150 : 1200);
        sec.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" });
        setTimeout(pick, reduced ? 200 : 1300);
      });
    });

    var queued = false;
    window.addEventListener("scroll", function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; pick(); });
    }, { passive: true });
    pick();
  })();

  /* ============================================================ book bar
     Hidden while the hero is in view or body.menu-open. IO + a class-
     attribute MutationObserver only; no scroll listeners. */
  (function bookbar() {
    var bar = document.querySelector(".bookbar");
    if (!bar) return;
    var hero = document.querySelector(".hero");
    var state = { heroVisible: !!hero, menuOpen: document.body.classList.contains("menu-open") };
    var apply = function () { bar.classList.toggle("is-hidden", state.heroVisible || state.menuOpen); };

    if (hero && hasIO) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { state.heroVisible = entry.isIntersecting; });
        apply();
      }).observe(hero);
    } else if (hero) {
      state.heroVisible = false;
    }

    if ("MutationObserver" in window) {
      new MutationObserver(function () {
        var open = document.body.classList.contains("menu-open");
        if (open === state.menuOpen) return;
        state.menuOpen = open;
        apply();
      }).observe(document.body, { attributes: true, attributeFilter: ["class"] });
    }
    apply();
  })();
})();

